<template>
  <div id="wrapper-navbar" :style="{ backgroundColor: $store.getters.getData.color1 }" :class="['navbar-'+ $store.getters.getData.template1, {'reverse navbar-browser': $store.getters.platform === 'browser', 'side-menu-on': sideMenuBrowser, 'iframe-nav': iframe}]">
    <div class="wrapper-img">
      <router-link to="/content" style="opacity: 1;">
        <img :src="$store.getters.getData.logo_mono" :alt="$store.getters.getData.name">
      </router-link>
    </div>

    <div class="nav-bars" @click="openNav">
      <icon name="bars" :scale="2.5" class="nav-bars" :style="{ color: bgColor1 }"></icon>
    </div>

    <div class="wrapper-nav-link" :style="{ color: bgColor1 }">
      <span v-on:keyup.enter="goLink('content')" class="nav-link" v-on:focus="onFocus">
        <router-link to="/content">{{ $t("MENU.CONTENTS") }}</router-link>
      </span>
      <span v-if="$store.getters.getData.is_shop" v-on:keyup.enter="goLink('shop')" class="nav-link">
        <router-link to="/shop">{{ $t("MENU.SHOP") }}</router-link>
      </span>
      <span v-if="$store.getters.getData.is_shop" v-on:keyup.enter="goLink('cart')" class="nav-link">
        <router-link to="/cart"><icon name="shopping-cart" :scale="1.4"></icon></router-link>
      </span>
      <span v-on:keyup.enter="goLink('settings')" class="nav-link">
        <router-link to="/settings"><icon name="cog" :scale="1.4"></icon></router-link>
      </span>
      <span v-on:keyup.enter="goLink('search')" class="nav-link">
        <router-link to="/search"><icon name="search" :scale="1.4"></icon></router-link>
      </span>
    </div>
  </div>
</template>

<script>
import SpatialNavigation from 'js-spatial-navigation'
import { getColorText } from '@/utils/helper-functions'
import { sideMenuBrowser } from '@/utils/constants'

export default {
  name: 'Navbar',
  data: function () {
    return {
      sideMenuBrowser: sideMenuBrowser,
      bgColor1: getColorText(this.$store.getters.client.color1)
    }
  },
  mounted () {
    this.SN = SpatialNavigation.add({selector: '#wrapper-navbar .nav-link', enterTo: 'last-focused'})
    SpatialNavigation.makeFocusable(this.SN)
    SpatialNavigation.focus(this.SN)
    SpatialNavigation.setDefaultSection(this.SN)
  },
  methods: {
    openNav: function () {
      document.getElementById('sidenav-app').style.width = 'auto'
    },
    goLink (name) { this.$router.push({name: name}) },
    // left: function () {
    //   switch (this.$route.name) {
    //     case 'shop':
    //       this.$router.push({name: 'content'})
    //       break

    //     case 'cart':
    //       this.$router.push({name: 'shop'})
    //       break

    //     case 'settings':
    //       (this.$store.getters.getData.is_shop) ? this.$router.push({name: 'cart'}) : this.$router.push({name: 'content'})
    //       break
    //     default:
    //       this.$router.push({name: 'settings'})
    //   }
    // },
    // right: function () {
    //   switch (this.$route.name) {
    //     case 'content':
    //       (this.$store.getters.getData.is_shop) ? this.$router.push({name: 'shop'}) : this.$router.push({name: 'settings'})
    //       break

    //     case 'shop':
    //       this.$router.push({name: 'cart'})
    //       break

    //     case 'cart':
    //       this.$router.push({name: 'settings'})
    //       break
    //     default:
    //       this.$router.push({name: 'content'})
    //   }
    // }
    onFocus: function () {
      // scroll top (tv)
      document.querySelector('#app-content').scrollTop = 0
      document.getElementById('app').scrollIntoView()
    }
  },
  computed: {
    iframe: function () {
      return (typeof this.$route.query.iframe) !== 'undefined' && this.$store.getters.platform === 'browser'
    }
  },
  beforeDestroy: function () { if (this.SN) SpatialNavigation.remove(this.SN) }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>

#wrapper-navbar
  position: relative
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  align-items: center;
  -webkit-align-items: center;
  height: 75px;
  max-height: 75px;
  width: 100%
  outline: none;
  padding: 0 2rem 0 2rem

  .wrapper-img
    max-width: 12vw;
    min-width: 100px
    max-height: inherit;
    // padding-left: 2rem;

    a
      margin: 0
      max-height: inherit;

      img
        max-width: 100%;
        height: auto;
        max-height: inherit;

  a
    display: inline-block;
    color: inherit;
    text-decoration: none;
    margin-right: 1.2rem;
    opacity: 0.5;
    font-size: 1.5rem
    // transition: transform .3s;

    border-bottom-width: thin;
    border-bottom-style: solid;
    border-bottom-color: transparent;

  // a:last-child
  //   margin-right: 2.2rem;

  a:hover
    opacity: 1;

  a.router-link-exact-active
    opacity: 1;

// #wrapper-navbar:focus a.router-link-exact-active
//   transform: scale(1.2);
//   transition: transform .3s;

.nav-link
  outline: none;

.nav-link:focus a
  border-bottom-width: thin;
  border-bottom-style: solid;
  border-bottom-color: transparent;

.nav-bars
  display: none
  margin-right: 1.2rem
  cursor:pointer!important

.navbar-browser.side-menu-on .nav-bars
  display: block

.navbar-browser.side-menu-on .wrapper-nav-link
  display: none

#wrapper-navbar.navbar-browser.side-menu-on
  flex-direction: row-reverse

@media screen and (max-width: 576px)
  #wrapper-navbar.navbar-browser
    flex-direction: row-reverse

  .navbar-browser .nav-bars
    display: block

  .navbar-browser .wrapper-nav-link
    display: none

.iframe-nav
  .wrapper-img, .wrapper-nav-link
    display: none!important
</style>



// WEBPACK FOOTER //
// src/templates/default/components/nav-bar.vue